import { factory, getResponseCamelization } from '@repo-level/core-front';
import { DOMAINS, TEMPORARY_ENV } from 'helpers/constants';

export interface IMissionProgressAddon {
  groups: string[];
  progress: number;
}

export interface IMissionProgressStreak {
  currentStreak: number;
  dailyBetCount: number;
  dailyGoal: number;
  streakGoal: number;
  lastActiveDate: string;
  isCompleted: boolean;
}

export interface IMissionProgressItem {
  value?: number;
  goal?: number;
  progress: number;
  addons?: IMissionProgressAddon[];
  streak?: IMissionProgressStreak;
}

export interface IAssignMission {
  success?: boolean;
  missionId?: string;
  groupId?: number;
  message?: string;
}

export type TMissionsProgressResponse = Record<string, IMissionProgressItem>;

const getMissionBaseUrl = () => {
  const { hostname } = window.location;
  const isDevEnv =
    hostname.includes(DOMAINS.LOCAL) || hostname.includes(TEMPORARY_ENV);

  return `https://gm-old-le02-prod.${isDevEnv ? DOMAINS.MAIN : hostname}`;
};

export const missionsProgress = factory(
  (r) => () =>
    r<TMissionsProgressResponse>(
      'get',
      `${getMissionBaseUrl()}/mission/results`,
      undefined,
      { transformResponse: [getResponseCamelization()] }
    )
);

export const assignMission = factory(
  (r) => (missionId: string) =>
    r<IAssignMission>('post', `${getMissionBaseUrl()}/mission/assign`, {
      missionId,
    })
);
